export default __webpack_public_path__ + "static/media/img-2.1a43f86c.jpg";